import React from 'react';
import { PlayIcon, FilePlusIcon } from 'lucide-react';
import { Link } from '@tanstack/react-router';

interface AutomationCardProps {
  title: string;
  description?: string;
  status?: string;
  linkUrl?: string;
}

const AutomationCard: React.FC<AutomationCardProps> = ({
  title,
  description,
  status,
  linkUrl,
}) => {
  return (
    <div className="rounded-2xl border border-gray-200 shadow-sm bg-white p-4 w-full max-w-md mx-auto">
      <div className="relative rounded-xl border border-gray-100 bg-gray-50 p-6 flex items-center justify-center mb-4 min-h-[160px] overflow-hidden">
        {/* Dotted grid background */}
        <svg
          className="absolute inset-0 w-full h-full pointer-events-none"
          width="100%"
          height="100%"
          viewBox="0 0 100 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <defs>
            <pattern id="dots" x="0" y="0" width="6" height="6" patternUnits="userSpaceOnUse">
              <circle cx="1" cy="1" r="0.5" fill="#e5e7eb" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#dots)" />
        </svg>
        {/* Icon row clickable */}
        <div className="relative z-10 w-full flex items-center justify-center">
          {linkUrl ? (
            <Link to={linkUrl} className="flex items-center justify-center gap-8 w-full" tabIndex={-1}>
              <span className="flex items-center justify-center rounded-xl bg-blue-50 p-2">
                <PlayIcon className="w-6 h-6 text-blue-500" />
              </span>
              <span className="border-t-2 border-dashed border-gray-400 w-12 h-2" />
              <span className="flex items-center justify-center rounded-xl bg-blue-50 p-2">
                <FilePlusIcon className="w-6 h-6 text-blue-500" />
              </span>
            </Link>
          ) : (
            <div className="flex items-center justify-center gap-8 w-full">
              <span className="flex items-center justify-center rounded-xl bg-blue-50 p-2">
                <PlayIcon className="w-6 h-6 text-blue-500" />
              </span>
              <span className="border-t-2 border-dashed border-gray-400 w-12 h-2" />
              <span className="flex items-center justify-center rounded-xl bg-blue-50 p-2">
                <FilePlusIcon className="w-6 h-6 text-blue-500" />
              </span>
            </div>
          )}
        </div>
      </div>
      {linkUrl ? 
      <Link to={linkUrl} className="block">
      <div className="flex items-center justify-between mt-2">
        <div>
          <div className="text-lg text-black font-medium leading-tight">{title}</div>
          {description && (
            <div className="text-sm text-gray-400 mt-1">{description}</div>
          )}
        </div>
        {status && (
          <span className="bg-blue-100 text-blue-700 border-blue-700 border-[0.5px] text-xs font-medium px-2 py-1 rounded-lg">{status}</span>
        )}
      </div>
      </Link>
       : <div className="flex items-center justify-between mt-2">
        <div>
          <div className="text-lg text-black font-medium leading-tight">{title}</div>
          {description && (
            <div className="text-sm text-gray-400 mt-1">{description}</div>
          )}
        </div>
        {status && (
          <span className="bg-blue-100 text-blue-700 border-blue-700 border-[0.5px] text-xs font-medium px-2 py-1 rounded-lg">{status}</span>
        )}
      </div>}
    </div>
  );
};

export default AutomationCard; 